import { useEffect, useState } from 'react'
import { api, type VisitaResumo } from './api/cliente'
import { Entrar } from './telas/Entrar'
import { Visita } from './telas/Visita'
import { Visitas } from './telas/Visitas'
import { Auditores } from './telas/Auditores'

/**
 * Três telas e um login. **A web lista e entrega, e nada mais** — sem nota, sem resposta de
 * questão, sem edição, sem reabrir quadro. Console analítico está fora de escopo e continua fora.
 *
 * A terceira é a das contas, de 02/09/2026. Ela não é console analítico: é o que substitui o
 * cadastro anônimo do Identity, que numa VM pública era porta aberta.
 *
 * **Quem manda na sessão é o cliente da API, não esta tela.** O token expira no meio de qualquer
 * coisa, e antes de 02/09/2026 isso deixava a pessoa parada numa página que não carregava mais
 * nada: o token era limpo e nada aqui ficava sabendo. A inscrição abaixo é o que traz a notícia, e
 * vale tanto para o 401 quanto para o botão de sair — que assim não precisa recarregar a página.
 */
export function App() {
  const [autenticado, setAutenticado] = useState(api.autenticado)
  const [aberta, setAberta] = useState<VisitaResumo | null>(null)
  const [emContas, setEmContas] = useState(false)
  const [aviso, setAviso] = useState<string | null>(null)

  useEffect(() => {
    function voltaAoLogin() {
      setAviso(api.motivoDaSaida)
      setAutenticado(false)
      // Sem isto, entrar de novo cairia direto onde a sessão morreu, e não na lista.
      setAberta(null)
      setEmContas(false)
    }

    const cancela = api.aoPerderSessao(voltaAoLogin)

    // **Efeito de filho roda antes do efeito do pai.** A lista de visitas dispara a requisição no
    // efeito dela, que corre antes deste — se a resposta for 401 e chegar antes desta linha, o
    // aviso não encontra ninguém inscrito. Conferir o estado ao assinar fecha essa fresta.
    if (!api.autenticado) voltaAoLogin()

    return cancela
  }, [])

  if (!autenticado)
    return (
      <Entrar
        aviso={aviso}
        aoEntrar={() => {
          setAviso(null)
          setAutenticado(true)
        }}
      />
    )

  if (emContas) return <Auditores aoVoltar={() => setEmContas(false)} />

  return aberta ? (
    <Visita visitaId={aberta.id} aoVoltar={() => setAberta(null)} />
  ) : (
    <Visitas aoAbrir={setAberta} aoAbrirContas={() => setEmContas(true)} />
  )
}
